export default __webpack_public_path__ + "static/media/红色高跟鞋.5412f8de.mp3";